const state = {
    riskCharter: '',
};

const mutations = {
    setRiskCharter(state, value) {
        state.riskCharter = value;
    },
};

const actions = {};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
